import React, { FC, useState, useRef, useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import platform from 'platform'
import history from '../../../history'

import {
  UnallowedRedirectContainer,
  QueueInfoBanner,
  ButtonContainer,
  BannerButton,
  QueueBannerInfoValue,
  QueueBannerInfoText,
} from '../styles/ConferencesScreenStyles'

import VideosList from './VideosList'

interface UnallowedDevicesRedirectProps {}

const UnallowedDevicesRedirect: FC<UnallowedDevicesRedirectProps> = ({}) => {
  const redirectUser = () => {
    history.push('/')
  }

  return (
    <UnallowedRedirectContainer>
      <QueueInfoBanner className="unallowed-redirect">
        <QueueBannerInfoValue className="margin-bottom color-white">
          Niestety t reningi wspólne nie są obsługiwane na{' '}
          {isMobile
            ? 'urządzeniach mobilnych'
            : platform.name == 'Safari'
            ? 'przeglądarce safari'
            : null}
        </QueueBannerInfoValue>
        <QueueBannerInfoText className="smaller-font color-white">
          By wziąć udział w treningu spróbuj skorzystać z przeglądarki Chrome na
          komputerze.
        </QueueBannerInfoText>
        <ButtonContainer>
          <BannerButton onClick={() => redirectUser()} className="padding-big">
            Wróć
          </BannerButton>
        </ButtonContainer>
      </QueueInfoBanner>
    </UnallowedRedirectContainer>
  )
}

export default UnallowedDevicesRedirect
